var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import DistanceDropdown, { DISTANCE_TITLE } from 'components/DistanceDropdown';
import FacilityTypeDropdown, { FACILITY_TITLE } from 'components/FacilityTypeDropdown';
import VerifiedDropdown, { VERIFIED_TITLE } from 'components/VerifiedDropdown';
import NetworkDropdown, { NETWORK_TITLE } from 'components/NetworkDropdown';
import ConfidenceDropdown, { CONFIDENCE_TITLE } from 'components/ConfidenceDropdown';
import DynamicFiltersBar from 'components/DynamicFiltersBar';
var distanceTooltipText = 'Enter Location details to enable Distance filter';
var FacilitiesFilters = function (_a) {
    var _b = _a.filterValues, filterValues = _b === void 0 ? {} : _b, filtersUpdate = _a.filtersUpdate, filtersUpdateSeveral = _a.filtersUpdateSeveral, onResetFilters = _a.onResetFilters, _c = _a.planTiers, planTiers = _c === void 0 ? [] : _c, _d = _a.isStandalonePage, isStandalonePage = _d === void 0 ? false : _d;
    var _e = useState(Date.now() + 1), distanceResetKey = _e[0], setDistanceResetKey = _e[1];
    var _f = useState(!!filterValues.distance), shouldResetDistance = _f[0], setShouldResetDistance = _f[1];
    var _g = useState(false), isNetworkEnabled = _g[0], setIsNetworkEnabled = _g[1];
    var isAddressEntered = !!filterValues.address;
    var resetDistance = function () {
        filtersUpdate('distance', 20);
        setDistanceResetKey(Date.now());
    };
    useEffect(function () {
        if (!filterValues.address && filterValues.distance) {
            resetDistance();
        }
        setShouldResetDistance(false);
        // eslint-disable-next-line
    }, [shouldResetDistance, JSON.stringify(filterValues)]);
    useEffect(function () {
        var hasValidTier = planTiers && planTiers.find(function (i) { return !!i.uuid; });
        setIsNetworkEnabled(!!hasValidTier);
    }, [planTiers]);
    var verifiedDefaultValue = {
        verified_after: filterValues.verified_after,
        is_verified: filterValues.is_verified
    };
    var elements = __assign({ distance: {
            name: DISTANCE_TITLE,
            element: (_jsx(Tooltip, { placement: "bottomLeft", title: !isAddressEntered ? distanceTooltipText : '', children: _jsx("div", { children: _jsx(DistanceDropdown, { disabled: !isAddressEntered, onSave: function (value) {
                            filtersUpdate('distance', value);
                        }, defaultValue: filterValues.distance, dataTest: "facilitiesPageDistanceFilter" }) }, distanceResetKey) }))
        }, facility_type: {
            name: FACILITY_TITLE,
            element: (_jsx(FacilityTypeDropdown, { onSave: function (selectedItems) {
                    filtersUpdate('location_types', Array.isArray(selectedItems) ? JSON.stringify(selectedItems) : undefined);
                }, defaultValue: filterValues.location_types
                    ? JSON.parse(filterValues.location_types)
                    : undefined, dataTest: "facilitiesPageTypeFilter" }))
        }, is_verified: {
            name: VERIFIED_TITLE,
            element: (_jsx(VerifiedDropdown, { defaultValue: verifiedDefaultValue, filtersUpdateSeveral: filtersUpdateSeveral, dataTest: "facilitiesPageVerifiedFilter" }))
        }, min_confidence: {
            name: CONFIDENCE_TITLE,
            element: (_jsx(ConfidenceDropdown, { onSelect: function (value) { return filtersUpdate('min_confidence', value); }, defaultValue: filterValues.min_confidence, dataTest: "facilitiesPageConfidenceFilter" }))
        } }, (isStandalonePage && {
        insurance_plan_tiers: {
            name: NETWORK_TITLE,
            element: (_jsx(NetworkDropdown, { planId: filterValues.plan_id, onSave: function (selectedItems) {
                    filtersUpdate('insurance_plan_tiers', (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length)
                        ? JSON.stringify(selectedItems)
                        : undefined);
                }, defaultValue: filterValues.insurance_plan_tiers
                    ? JSON.parse(filterValues.insurance_plan_tiers)
                    : undefined, disabled: !isNetworkEnabled || !filterValues.plan_id, dataTest: "facilitiesPageNetworkFilter" }))
        }
    }));
    return (_jsx(DynamicFiltersBar, { elements: elements, filterValues: filterValues, resetFilters: onResetFilters, defaultActiveKeys: [
            'distance',
            'facility_type',
            'is_verified',
            'min_confidence'
        ] }));
};
export default FacilitiesFilters;
